/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
//import history from './history'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	user: '',
    role: '',
    avatar: null,
 	  loading: false,
    drawer: false,
    allowBack: true,
    version: null
  },
  modules: {
    //history
  },
  mutations: {
    signIn(state, token) {
  	  localStorage.setItem('token', token.userId)
      localStorage.setItem('username', token.nickname)
      localStorage.setItem('email', token.email)
      localStorage.setItem('role', token.role)
      localStorage.setItem('currency', token.currency)
      localStorage.setItem('initial', token.initial)
      localStorage.setItem('brand', token.brand)
      localStorage.setItem('practiceId', token.practiceId)
      localStorage.setItem('office', token.office)
      sessionStorage.setItem('token', token.userId)
      sessionStorage.setItem('username', token.nickname)
      sessionStorage.setItem('email', token.email)
      sessionStorage.setItem('role', token.role)
      sessionStorage.setItem('currency', token.currency)
      sessionStorage.setItem('initial', token.initial)
      sessionStorage.setItem('brand', token.brand)
      sessionStorage.setItem('practiceId', token.practiceId)
      sessionStorage.setItem('office', token.office)
  	  state.user = token
      state.role = token.role
  	},
    userRole(state, token) {
      localStorage.setItem('role', token.role)
      sessionStorage.setItem('role', token.role)
      state.role = token.role

      localStorage.setItem('avatar', token.avatar)
      sessionStorage.setItem('avatar', token.avatar)
      state.avatar = token.avatar
    },
  	signOut(state) {
  	  localStorage.removeItem('token')
      sessionStorage.removeItem('token')
      localStorage.removeItem('username')
      sessionStorage.removeItem('username')
      localStorage.removeItem('role')
      sessionStorage.removeItem('role')
      localStorage.removeItem('currency')
      sessionStorage.removeItem('currency')
      localStorage.removeItem('initial')
      sessionStorage.removeItem('initial')
      localStorage.removeItem('email')
      sessionStorage.removeItem('email')
      localStorage.removeItem('brand')
      sessionStorage.removeItem('brand')
      localStorage.removeItem('practiceId')
      sessionStorage.removeItem('practiceId')
      localStorage.removeItem('office')
      sessionStorage.removeItem('office')
  	  state.user = null
      state.role = null
      state.avatar = null
  	},
  	showLoading(state) {
      state.loading = true    
    },
    hideLoading (state) {
      state.loading = false
    },
    setDrawer(state, token) {
      state.drawer = token
    },
    setVersion(state, v) {
      state.version = v
    },
    updateAppSetting(state, status) {
      state.allowBack = status.allowBack
    }
  },
  actions: {
    updateAppSetting({commit}, status){
      commit('updateAppSetting', status)
    }
  }
})
